import Text from "./Text"
const AGB = () => {
    return (
        <div className="h-full overflow-y-auto p-6 flex flex-col gap-4">
            <Text type="main">Allgemeine Geschäftsbedingungen (AGB)</Text>

            <Text>
                Stand: Januar 2026
            </Text>

            <Text>
                Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der Plattform
                <strong> Cashier One</strong> (nachfolgend "die Plattform" genannt), bestehend aus Webanwendung und Android-App.
            </Text>

            <Text type="title">1. Geltungsbereich</Text>
            <Text>
                Diese AGB gelten für alle Nutzer von Cashier One. Mit der Registrierung oder Nutzung
                der Plattform erklärst du dich mit diesen AGB einverstanden. Abweichende Bedingungen
                werden nicht anerkannt, es sei denn, wir stimmen ihrer Geltung ausdrücklich schriftlich zu.
            </Text>

            <Text type="title">2. Leistungsbeschreibung</Text>
            <Text>
                Cashier One ist eine digitale Kassen- und Verwaltungssoftware für Gastronomiebetriebe.
                Der konkrete Funktionsumfang richtet sich nach dem jeweils gewählten Abonnement.
                Die Plattform ermöglicht die Erfassung von Verkäufen, Produktverwaltung, Statistiken
                und weitere für den Kassenbetrieb relevante Funktionen.
            </Text>

            <Text type="title">3. Registrierung & Nutzung</Text>
            <Text>
                Die Nutzung der Plattform setzt eine Registrierung voraus. Du verpflichtest dich,
                bei der Registrierung wahrheitsgemäße und vollständige Angaben zu machen. Zugangsdaten
                sind vertraulich zu behandeln und dürfen nicht an Dritte weitergegeben werden.
                Du bist für alle Aktivitäten innerhalb deines Workspaces verantwortlich und verpflichtet,
                uns unverzüglich zu informieren, falls du von einer unbefugten Nutzung deines Kontos
                Kenntnis erlangst.
            </Text>

            <Text type="title">4. Abonnements, Preise & Laufzeiten</Text>
            <Text>
                Die Abrechnung erfolgt pro Workspace, nicht pro Gerät. Die jeweils gültigen Preise
                und Leistungsumfänge sind auf der Website einsehbar. Abonnements werden wahlweise
                monatlich oder jährlich abgeschlossen und verlängern sich automatisch um den
                jeweiligen Zeitraum, sofern nicht rechtzeitig gekündigt wird.
            </Text>
            <Text>
                Preisänderungen behalten wir uns vor, werden diese jedoch mindestens 30 Tage im
                Voraus ankündigen. Bei Preiserhöhungen steht dir ein Sonderkündigungsrecht zu.
            </Text>

            <Text type="title">5. Zahlungsabwicklung</Text>
            <Text>
                Die Zahlung erfolgt über die angebotenen Zahlungsanbieter im Voraus für den
                jeweiligen Abrechnungszeitraum. Bei ausstehenden Zahlungen trotz Mahnung kann
                der Zugriff auf die Plattform eingeschränkt oder gesperrt werden. Deine Daten
                bleiben dabei für einen Zeitraum von 30 Tagen gespeichert, um dir die Möglichkeit
                zur Zahlung und Wiederherstellung zu geben.
            </Text>

            <Text type="title">6. Kündigung & Widerrufsrecht</Text>
            <Text>
                Monatliche Abonnements können mit einer Frist von 7 Tagen zum Monatsende gekündigt
                werden. Jährliche Abonnements können mit einer Frist von 30 Tagen zum Vertragsende
                gekündigt werden. Die Kündigung erfolgt über die Plattform.
            </Text>
            <Text>
                Bei Neuabschluss eines Abonnements hast du ein gesetzliches Widerrufsrecht von
                14 Tagen. Wenn du jedoch die sofortige Nutzung der Plattform wünschst, verzichtest
                du auf dieses Widerrufsrecht, sobald du mit der Nutzung beginnst.
            </Text>
            <Text>
                Eine Rückerstattung bereits gezahlter Beträge erfolgt nur im Rahmen des
                Widerrufsrechts. Bei unterjähriger Kündigung eines Jahresabos erfolgt keine
                anteilige Rückerstattung.
            </Text>

            <Text type="title">7. Verfügbarkeit & Gewährleistung</Text>
            <Text>
                Wir bemühen uns um eine hohe Verfügbarkeit der Plattform von mindestens 98%
                im Jahresdurchschnitt (ausgenommen geplante Wartungsarbeiten). Eine
                unterbrechungsfreie Nutzung können wir jedoch nicht garantieren. Wartungsarbeiten
                werden nach Möglichkeit außerhalb der üblichen Geschäftszeiten durchgeführt und
                im Voraus angekündigt.
            </Text>
            <Text>
                Die Plattform wird in dem zum Zeitpunkt des Vertragsschlusses beschriebenen
                Zustand bereitgestellt. Wir garantieren nicht, dass die Software fehlerfrei ist,
                bemühen uns jedoch um schnelle Behebung gemeldeter Fehler.
            </Text>

            <Text type="title">8. Offline-Nutzung & Datensynchronisation</Text>
            <Text>
                Eine eingeschränkte Offline-Nutzung ist möglich, sofern zuvor eine Online-Anmeldung
                erfolgt ist. Daten werden bei erneuter Internetverbindung automatisch synchronisiert.
                Du bist selbst dafür verantwortlich, regelmäßig eine Internetverbindung herzustellen,
                um Datenverluste zu vermeiden. Bei längerer Offline-Nutzung können Konflikte bei
                der Synchronisation auftreten.
            </Text>

            <Text type="title">9. Datenverantwortung & Backup</Text>
            <Text>
                Wir erstellen regelmäßige Backups deiner Daten. Dennoch empfehlen wir dir,
                eigenständig Sicherungskopien wichtiger Daten anzulegen, insbesondere durch
                regelmäßigen Export deiner Verkaufsdaten. Nach Beendigung des Vertrags stellen
                wir deine Daten für einen Zeitraum von 30 Tagen zum Export bereit, danach werden
                sie gelöscht.
            </Text>
            <Text>
                Die in der Plattform erfassten Daten bleiben dein Eigentum. Wir gewähren uns
                lediglich das Recht, diese Daten zur Bereitstellung der Dienstleistung zu nutzen.
            </Text>

            <Text type="title">10. Steuerrechtliche Pflichten</Text>
            <Text>
                Du bist selbst für die Einhaltung aller steuerrechtlichen Vorschriften verantwortlich,
                insbesondere der Aufbewahrungspflicht von Geschäftsunterlagen (in der Schweiz
                grundsätzlich 10 Jahre). Die Plattform bietet Export-Funktionen, die dir die
                Erfüllung dieser Pflichten erleichtern sollen. Du verpflichtest dich, die Plattform
                nur im Rahmen der geltenden gesetzlichen Bestimmungen zu nutzen.
            </Text>

            <Text type="title">11. Haftung</Text>
            <Text>
                Wir haften nach den gesetzlichen Bestimmungen bei Vorsatz und grober Fahrlässigkeit.
                Bei leichter Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten
                (Kardinalpflichten) und ist die Haftung auf den vertragstypischen, vorhersehbaren
                Schaden begrenzt.
            </Text>
            <Text>
                Die Haftung für Datenverluste ist auf den typischen Wiederherstellungsaufwand
                beschränkt, der bei regelmäßiger und angemessener Anfertigung von Sicherungskopien
                eingetreten wäre. Eine Haftung für indirekte Schäden, entgangenen Gewinn oder
                Folgeschäden ist ausgeschlossen, soweit gesetzlich zulässig.
            </Text>
            <Text>
                Die vorstehenden Haftungsbeschränkungen gelten nicht bei Verletzung von Leben,
                Körper oder Gesundheit.
            </Text>

            <Text type="title">12. Pflichten des Nutzers</Text>
            <Text>
                Du verpflichtest dich, die Plattform nicht zu missbräuchlichen Zwecken zu nutzen,
                insbesondere nicht zur Verbreitung von Schadsoftware, zur Vornahme von Hacking-Versuchen
                oder zur Verletzung von Rechten Dritter. Bei Verstößen sind wir berechtigt, dein
                Konto ohne Vorankündigung zu sperren.
            </Text>

            <Text type="title">13. Änderungen der AGB</Text>
            <Text>
                Wir behalten uns vor, diese AGB bei sachlichem Grund anzupassen, insbesondere bei
                Änderungen der Rechtslage, technischen Weiterentwicklungen oder neuen Funktionen.
                Über wesentliche Änderungen werden wir dich mindestens 30 Tage im Voraus informieren.
                Widersprichst du nicht innerhalb dieser Frist, gelten die neuen AGB als akzeptiert.
                Bei Widerspruch steht dir ein Sonderkündigungsrecht zu.
            </Text>

            <Text type="title">14. Salvatorische Klausel</Text>
            <Text>
                Sollten einzelne Bestimmungen dieser AGB unwirksam oder undurchführbar sein oder werden,
                wird dadurch die Wirksamkeit der übrigen Bestimmungen nicht berührt. An die Stelle der
                unwirksamen Bestimmung tritt eine Regelung, die dem wirtschaftlichen Zweck der
                unwirksamen Bestimmung am nächsten kommt.
            </Text>

            <Text type="title">15. Anwendbares Recht & Gerichtsstand</Text>
            <Text>
                Es gilt ausschließlich schweizerisches Recht unter Ausschluss des UN-Kaufrechts.
                Gerichtsstand für alle Streitigkeiten ist, soweit gesetzlich zulässig, der Sitz
                des Anbieters (Beringen, Schweiz).
            </Text>
        </div>
    );
}
export default AGB